import { useStatusContext } from "/app/src/contexts/hooks/useStatusContext";
import { Trans } from "react-i18next";

/**
 * Component to display a banner when software update is due
 * Shows banner based on release date and SLA status:
 * - SLA environments: >= 102 weeks (714 days)
 * - Non-SLA environments: >= 50 weeks (350 days)
 */
export default function SoftwareUpdateBanner() {
  const { releaseDate, hasSLA, hasSLAExists } = useStatusContext();

  // Don't show banner if no release date is available or hasSLAExists is not true
  if (!releaseDate || !hasSLAExists) {
    return null;
  }

  // Calculate weeks since release date
  // Normalize both dates to UTC to avoid timezone issues
  const releaseDateObj = new Date(releaseDate);
  const currentDate = new Date();

  // Get UTC timestamps
  const releaseUTC = Date.UTC(
    releaseDateObj.getUTCFullYear(),
    releaseDateObj.getUTCMonth(),
    releaseDateObj.getUTCDate(),
  );
  const currentUTC = Date.UTC(
    currentDate.getUTCFullYear(),
    currentDate.getUTCMonth(),
    currentDate.getUTCDate(),
  );

  const diffTime = currentUTC - releaseUTC;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  const weeksSinceRelease = Math.floor(diffDays / 7);

  // Determine threshold based on SLA status
  const weekThreshold = hasSLAExists && hasSLA ? 102 : 50;

  // Show banner if weeks since release meets or exceeds threshold
  if (weeksSinceRelease >= weekThreshold) {
    return (
      <div className="statusMessage warning">
        <Trans
          i18nKey="translation:software_update_required"
          components={{
            1: (
              // skipcq: JS-0738
              <a
                href="https://itempath.com/support-services"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white underline"
              />
            ),
            3: (
              // skipcq: JS-0738
              <a
                href="mailto:support@itempath.com"
                className="text-white underline"
              />
            ),
          }}
        />
      </div>
    );
  }

  return null;
}
